export default __webpack_public_path__ + "static/media/new_oxo_face.c82d52dc.svg";